import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'

import * as apiCompany from "../../../../api/apiCompany"
import * as Auth from "../../../Login/Auth"
import { RoleContent } from './RoleContent';
import { SubmitButton, CancelButton } from '../../Res/BaseButton';
import { ContentBox } from '../../Content/ContentBox';

export function AdminRoleAdd ({departmentId, getRoleList}) {
  const [roleName, setRoleName] = useState("")
  const [isSupervisor, setIsSupervisor] = useState(false)
  const [managerRoleId, setManagerRoleId] = useState("")
  const [isDisable, setisDisable] = useState(false)
  const [change, setChange] = useState(false)

  var title = '角色 - 新增'
  var title_tools = ''
  var content = <RoleContent departmentId={departmentId} sn={setRoleName} ss={setIsSupervisor} sm={setManagerRoleId} sd={setisDisable} change={change} />
  var footer =
    <div class="row">
      <div class="col-sm-3 col-sm-offset-9">
        <SubmitButton action={toAdd} isRight={true} />
        <CancelButton action={toCancel} isRight={true} />
      </div>
    </div>

  
  function toAdd(){
    if(roleName !== ""){
      var token = Auth.getToken();
      apiCompany.roleAdd({roleName, departmentId, isSupervisor, managerRoleId, isDisable, 
        success: (obj)=>{
          Swal.fire({
            type: 'success',
            title: '提醒',
            text: '新增成功',
          }).then(function() {
            setRoleName("")
            setIsSupervisor(false)
            setManagerRoleId("")
            setisDisable(false)
            getRoleList();
            setChange(!change)
            //window.history.replace("/ManagerList");
          })
        },
        failure: ()=>{

        }
      })
    }else{
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: '公司名稱 不得為空',
      })
    }
  }

  function toCancel(){
    setRoleName("")
    setIsSupervisor(false)
    setManagerRoleId("")
    setisDisable(false)
  }


  return (    
    <ContentBox title={title} title_tools={title_tools} content={content} footer={footer}  hasDrawer={true} />
  )
}